import {BaseModel} from "./base-model";
import {Location} from "./location";
import {ProductionLine} from "./production-line";
import {Utils} from "../utils";
import {Personnel} from './personnel';

export enum FieldServiceType {
  PLANT,
  DEPARTMENT,
  PRODUCTION_LINE,
  WORK_CENTER
}

export class FieldService extends BaseModel {

  protected static self = FieldService;

  id: string;
  name: string;
  typeId: number;
  description: string;
  locationId: string;
  location: Location;
  productionLineId: string;
  productionLine: ProductionLine;

  constructor() {
    super();
    this.location = new Location();
    this.productionLine = new ProductionLine();
  }

  public validate(): boolean {
    return !Utils.isEmpty(this.name) && (this.location.isEmpty() || this.location.validate());
  }
}

export class UserFieldServiceAssignment extends BaseModel {

  protected static self = UserFieldServiceAssignment;

  user: Personnel;
  fieldService: FieldService;
  isManager: boolean;
}
